import {bindable, bindingMode, customAttribute, DOM, inject} from 'aurelia-framework';
import {EventAggregator} from 'aurelia-event-aggregator';
import {indexOfNode} from '../../../tools/dom';
import {noop, get} from 'lodash';
import 'dragula/dist/dragula.css';
import dragula, {Drake} from 'dragula';

@inject(DOM.Element, EventAggregator)
@customAttribute('dragula')
export class Dragula {

  @bindable({
    attribute: 'mirror-cont',
    defaultBindingMode: bindingMode.oneTime
  }) mirrorContainer;

  @bindable({
    defaultBindingMode: bindingMode.oneTime
  }) drop = noop;

  @bindable({
    defaultBindingMode: bindingMode.oneTime
  }) canDrag: (x:any) => boolean = () => true;

  @bindable({
    defaultBindingMode: bindingMode.oneTime
  }) canDrop: (x: any) => boolean = () => true;

  private __dragulaApi: Drake;

  constructor(private __element: Element, private __ea: EventAggregator) {
  }

  bind() {
    const api = this.__initDragula().on('drop', (el) => {
      let dropIndex = indexOfNode(el);
      let dragIndex = (el as any).au.controller.scope.overrideContext.$index;
      this.drop({dragIndex, dropIndex});
      api.cancel();
    });
  }

  unbind() {
    this.__dragulaApi.destroy();
  }

  __initDragula() {
    return this.__dragulaApi = dragula([this.__element], {
      // copy: false,
      // copySortSource: false,
      direction: 'vertical',
      revertOnSpill: true,
      mirrorContainer: this.mirrorContainer,
      moves: (el) => this.canDrag(Dragula.getAuContext(el)),
      accepts: (el, target, source, sibling) => {
        let auContext = Dragula.getAuContext(sibling);
        let id = get(auContext, 'context.item.id', null);
        return id ? this.canDrop(auContext) : true;
      }
    });
  }

  /**
   * @param {Element} element
   * @static
   * @returns {Object}
   */
  static getAuContext(element) {
    return {
      context: get(element, 'au.controller.scope.bindingContext', {})
    };
  }

  // trackDrop(dragApi) {
  //   dragApi.on('drop', (el, container, source) => {
  //     let card = source.parentElement.card.card,
  //       pile = container.parentElement.parentElement.pile.pile;
  //     dragApi.cancel();
  //     this.eventAggregator.publish(new CardDroppedEvent(card, pile));
  //   });
  // }
  //
  // trackDraggingState(dragApi) {
  //   let handle;
  //   dragApi.on('drag', () => {
  //     handle = setTimeout(() => this.dragging = true, doubleClickDelay + 20);
  //   });
  //   dragApi.on('dragend', () => {
  //     clearTimeout(handle);
  //     this.dragging = false;
  //   });
  // }

}
